import { CallProvider, CallProviderId } from './types';

const adapters = new Map<CallProviderId, CallProvider>();

// no per-workspace provider selection exists yet; twilio is the only implemented provider
export const DEFAULT_PROVIDER: CallProviderId = 'twilio';

export function registerProvider(provider: CallProviderId, adapter: CallProvider) {
  adapters.set(provider, adapter);
}

export function getProvider(provider: CallProviderId) {
  return adapters.get(provider);
}
